module.exports = __webpack_public_path__ + "static/media/cube.c79a31ed.svg";